<template>
  <div class="chat-janela shadow-lg d-flex flex-column">
    <!-- Header -->
    <div class="chat-header d-flex justify-content-between align-items-center p-2 bg-primary text-white">
      <span>💬 Chat Interno</span>
      <b-button
        size="sm"
        variant="light"
        @click="$emit('fechar')"
      >
        ✖
      </b-button>
    </div>

    <!-- Corpo -->
    <div
      class="chat-body d-flex flex-grow-1"
      style="min-height: 0;"
    >
      <!-- Botão de toggle (visível quando sidebar estiver escondida) -->
      <div
        v-if="!sidebarAberta"
        class="toggle-sidebar p-2"
      >
        <b-button
          size="sm"
          variant="primary"
          @click="sidebarAberta = true"
        >
          ☰
        </b-button>
      </div>

      <!-- Lista de contatos -->
      <ListaConversas
        v-if="sidebarAberta"
        :usuario-logado="usuarioLogado"
        @selecionar="abrirConversa"
        @fecharSidebar="sidebarAberta = false"
      />

      <!-- Painel de mensagens -->
      <div class="flex-grow-1 d-flex flex-column">
        <ChatMensagens
          v-if="conversaSelecionada"
          :conversa="conversaSelecionada"
          :usuario-logado="usuarioLogado"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ListaConversas from './ListaConversas.vue'
import ChatMensagens from './ChatMensagens.vue'

export default {
  components: { ListaConversas, ChatMensagens },
  data() {
    return {
      conversaSelecionada: null,
      usuarioLogado: {
        id: 1,
        nome: 'Romário',
      },
      sidebarAberta: true,
    }
  },
  methods: {
    abrirConversa(conversa) {
      this.conversaSelecionada = conversa
    },
  },
}
</script>

  <style scoped>
  .chat-janela {
    position: fixed;
    bottom: 90px;
    right: 24px;
    width: 400px;
    height: 500px;
    background: white;
    border-radius: 8px;
    overflow: hidden;
    z-index: 9999;
  }

  .chat-body {
    flex: 1;
    display: flex;
    height: 100%;
    min-height: 0;
  }

  .toggle-sidebar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    border-right: 1px solid #eee;
  }
  </style>
